/**
 * The one place this domain builds an integration id.
 *
 * ─── The separator is an UNDERSCORE, and it is load-bearing ─────────────────
 * A systems-integration row's id is its `connectorId` and its
 * `integrationUserId` joined with `_`. Verified against every writer of that id:
 * `mercadolibreProvisioningFromSocialLogin.policy.ts:176`, `erpSyncMirrorWrite.ts:97`,
 * `operationDispatch.helpers.ts:79`, `integrations.aggregate.test.ts:52`, and the
 * front-end's own `AddChannelModal.tsx` (`id: \`${selectedChannel}_${integrationUserId}\``).
 *
 * It is spelled out here because it has already been got wrong once. The
 * aggregate's docstring said `[connectorId]-[integrationUserId]` with a HYPHEN;
 * `connectionWatchPolicy` trusted that comment, re-joined a batch process's
 * `connectorId` / `integrationUserId` with a hyphen, and so never matched a
 * running import to the channel it belonged to — the onboarding progress card
 * silently rendered nothing. The docstring has been corrected at its source; this
 * helper exists so the template is written ONCE rather than re-interpolated at
 * every comparison site, where the next `-` typo would be just as invisible.
 *
 * Not imported from `@bett3r-dev/teselly-domain-utils` — which does export a
 * `buildIntegrationId` — because that is a BACKEND package and is not a declared
 * dependency of the web app. If it is ever promoted to a shared package, delete
 * this and import it.
 */
export const buildIntegrationId = (
  connectorId: string,
  integrationUserId: string
): string => `${connectorId}_${integrationUserId}`;
